/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Decklists_Help_AllInputs */



/**
* | output |
* | --- |
* | "Once the event finishes, all submitted decklists become public." |
*
* @param {Tfield_Decklists_Help_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_decklists_help_all = /** @type {((inputs?: Tfield_Decklists_Help_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Decklists_Help_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une fois l'événement terminé, toutes les decklists soumises deviennent publiques.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una vez finalizado el evento, todas las decklists enviadas se hacen públicas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assim que o evento terminar, todas as decklists enviadas se tornam públicas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Al termine dell'evento, tutte le decklist inviate diventano pubbliche.")
	return /** @type {LocalizedString} */ ("Once the event finishes, all submitted decklists become public.")
});